import { normalizePagePath, pageMetadata } from './site-metadata';
import { seoArticles } from './seo-content';

export function pageStructuredData(path: string, origin: string) {
  path = normalizePagePath(path);
  const metadata = pageMetadata(path);
  if (!metadata?.index) return null;
  const url = `${origin}${path}`;
  const graph: Record<string, unknown>[] = [];
  if (path === '/') {
    graph.push(
      { '@type': 'Organization', '@id': `${origin}/#organization`, name: 'Relay', url: `${origin}/`, logo: { '@type': 'ImageObject', url: `${origin}/favicon.svg` } },
      { '@type': 'WebSite', '@id': `${origin}/#website`, name: 'Relay', alternateName: 'Relay Digital Business Cards', url: `${origin}/`, inLanguage: 'en', publisher: { '@id': `${origin}/#organization` } },
      { '@type': 'SoftwareApplication', '@id': `${origin}/#application`, name: 'Relay', url: `${origin}/`, applicationCategory: 'BusinessApplication', operatingSystem: 'Web', description: metadata.description, image: `${origin}/og-image.png`, offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD', url: `${origin}/pricing`, description: 'Free plan with two digital business cards.' }, featureList: ['Digital business cards', 'QR code and link sharing', 'Contact saving', 'Browser replies', 'Private connections, notes and tags'] },
    );
  } else {
    const name = seoArticles[path]?.label || ({ '/pricing': 'Pricing', '/help': 'Help', '/support': 'Support', '/privacy': 'Privacy policy', '/terms': 'Terms and conditions' } as Record<string, string>)[path] || metadata.title;
    graph.push({ '@type': 'BreadcrumbList', '@id': `${url}#breadcrumbs`, itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Relay', item: `${origin}/` },
      { '@type': 'ListItem', position: 2, name, item: url },
    ] });
  }
  graph.push({ '@type': 'WebPage', '@id': `${url}#webpage`, url, name: metadata.title, description: metadata.description, inLanguage: 'en', isPartOf: { '@id': `${origin}/#website` }, ...(path === '/' ? { about: { '@id': `${origin}/#application` } } : { breadcrumb: { '@id': `${url}#breadcrumbs` } }) });
  return { '@context': 'https://schema.org', '@graph': graph };
}

// Keep JSON data inside its script element even if future copy contains HTML.
export const serializeStructuredData = (value: unknown) => JSON.stringify(value).replace(/</g, '\\u003c');
